import React from 'react';
import { Card, CardBody, Col, Row, TabPane, Label } from 'reactstrap';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Switch from 'react-switch';

import PropTypes from 'prop-types';

import VendorDaysBack from '../Vendor/VendorsDaysBack';
import CMDBCompanyCheck from '../ServiceNow/CMDBCompanyCheck';
import CMDBAffectedCIQuery from '../ServiceNow/CMDBAffectedCIQuery';
import CMDBCompany from '../ServiceNow/CMDBCompany';

export default function DefaultConfigTab({
  activeTab,
  vendorId,
  vendor,
  vendorLabel,
  bugsDateBack,
  setBugsDateBack,
  isSubmitted,
  snCompanySysIdErrors,
  snCompanySysIdOptions,
  setSnCompanySysId,
  snCompanySysId,
  fields,
  handleFieldChange,
  autoClose,
  setAutoClose,
  children
}) {
  return (
    <div style={{ minWidth: '100%' }}>
      <TabPane tabId="3">
        {activeTab === '3' && (
          <Card bg={'light'} text={'dak'} className="mb-4">
            <CardBody>
              <Row>
                <Col lg="6">
                  <VendorDaysBack
                    bugsDateBack={bugsDateBack}
                    setBugsDateBack={setBugsDateBack}
                    isSubmitted={isSubmitted}
                    vendorId={vendorId}
                  />
                </Col>
                <Col lg="6">
                  {snCompanySysIdErrors === false ? (
                    <CMDBCompanyCheck
                      snCompanySysIdOptions={snCompanySysIdOptions}
                      setSnCompanySysId={setSnCompanySysId}
                      snCompanySysId={snCompanySysId}
                      isSubmitted={isSubmitted}
                    />
                  ) : (
                    <CMDBCompany
                      snCompanySysId={fields.snCompanySysId}
                      handleFieldChange={handleFieldChange}
                      isSubmitted={isSubmitted}
                    />
                  )}
                </Col>
              </Row>
              {vendor.cloudVendor !== 1 ? (
                <CMDBAffectedCIQuery
                  snAffectedCIQuery={fields.snAffectedCIQuery}
                  handleFieldChange={handleFieldChange}
                  isSubmitted={isSubmitted}
                />
              ) : null}
              {setAutoClose ? (
                <>
                  <Row>
                    <Col>
                      <Label className="">Select whether you want to auto close bug tickets in ServiceNow</Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Switch
                        onChange={() => setAutoClose(!autoClose)}
                        checked={autoClose}
                        onColor="#253746"
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={20}
                        width={40}
                        handleDiameter={16}
                      />
                    </Col>
                  </Row>
                </>
              ) : (
                <></>
              )}
              {children}
            </CardBody>
          </Card>
        )}
      </TabPane>
    </div>
  );
}

DefaultConfigTab.propTypes = {
  vendorLabel: PropTypes.string,
  vendorId: PropTypes.string,
  vendor: PropTypes.object,
  snCompanySysIdOptions: PropTypes.object,
  snCompanySysId: PropTypes.object,
  fields: PropTypes.object,
  handleFieldChange: PropTypes.func,
  activeTab: PropTypes.string,
  isSubmitted: PropTypes.bool,
  bugsDateBack: PropTypes.string,
  setBugsDateBack: PropTypes.func,
  snCompanySysIdErrors: PropTypes.bool,
  setSnCompanySysId: PropTypes.func,
  autoClose: PropTypes.bool,
  setAutoClose: PropTypes.func,
  children: PropTypes.node
};
